import { render, staticRenderFns } from "./LocationMoveOrder.vue?vue&type=template&id=4454c291"
import script from "./LocationMoveOrder.vue?vue&type=script&lang=js"
export * from "./LocationMoveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports